import { PreviewSize } from "../../../../../PanelProxi/Ver/PreviewSize"
import { Suscribir } from "../Vista/Suscribir"


export function Preview({ panel, size }: { panel: any, size: string }) {
    switch (panel.type) {
        case 'suscribir2': return <Suscribir key={'panel' + panel.id} data={panel} size={size} />
        default: return <PreviewSize key={'panel' + panel.id} panel={panel} size={size} />
    }
}